import { createFileRoute, redirect } from '@tanstack/react-router';
import { zSortDirection } from 'client/zod.gen';
import { isPersonAdmin } from 'helpers/query';
import { zFiltersArray } from 'helpers/router';
import { z } from 'zod';

export const usersSchema = z.object({
  active: zFiltersArray(),
  registered: zFiltersArray(),
  preregistered: zFiltersArray(),
  role: zFiltersArray(),
  company_id: zFiltersArray(),
  company_type: zFiltersArray(),
  user_type: zFiltersArray(),
  filtersDialog: z
    .enum(['user_status', 'company_type', 'company_id', 'role', 'user_type'])
    .optional(),
  sort: z
    .union([
      z.literal('email'),
      z.literal('first_name'),
      z.literal('last_name'),
      z.literal('full_name'),
      z.literal('created'),
      z.literal('last_login'),
      z.literal('teams_count'),
      z.literal('active'),
      z.literal('company_name'),
      z.literal('company_type'),
      z.literal('user_type'),
    ])
    .optional()
    .catch('full_name')
    .default('full_name'),
  order: zSortDirection.optional().catch('asc').default('asc'),
});

/** Default search for `/users` (admin directory). */
export const adminUsersListDefaultSearch: z.infer<typeof usersSchema> =
  usersSchema.parse({});

export const Route = createFileRoute('/_private/_route/users/')({
  beforeLoad: ({ context }) => {
    if (!isPersonAdmin(context.user)) {
      throw redirect({ replace: true, to: '/' });
    }
  },
  validateSearch: usersSchema,
});
